








































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import MyPageInfo from '@/app/components/MyPage/MyPageInfo.vue'
import Toast from '@/app/components/Common/Toast.vue'
/* api */
import MypageApi from '@/app/model/api/mypageApi'
/* module */
import CommonClass from '@/app/module/common'
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import { routerPath } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    MyPageInfo,
    Toast
  }
})
export default class Mypage extends Vue {
  private userData: any = {}
  private showNotFound: boolean = false
  private showInfoLoading: boolean = true
  private showListLoading: boolean = true
  private showErrorAlert: boolean = false
  private alertText: string = ''

  created () {
    (async () => {
      const user = await MypageApi.getMypageData()
      this.$store.commit('routeState/setRoute', this.$route.path)

      if (user.isOk()) {
        this.userData = user.getPayload()
        this.showInfoLoading = false
      } else if (user.checkTimeoutErrorStatus()) {
        this.$store.commit('routeState/setTimeoutErrorFlag', true)
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (user.checkErrorStatus()) {
        this.$store.commit('routeState/setErrorFlag', true)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (user.checkNotFoundStatus()) {
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (user.checkStatus()) {
        CommonClass.doLogout()
      } else {
        this.showInfoLoading = false
        this.showErrorAlert = true
        this.alertText = user.getPayload().message
      }
    })()
  }

  public showErrorToast (msg: string) {
    this.showErrorAlert = false
    this.alertText = msg
    this.showErrorAlert = true
  }

  private closeAlert () {
    this.showErrorAlert = false
  }
}
